import { useLayoutEffect, useRef, useState } from "react";
import Footer from "./Components/Footer";
import Navbar from "./Components/Navbar";
import AllRouter from "./Router/AllRouter";
import "./Locomotive.css";
import gsap from "gsap";
import { ThemeProvider } from "./Theme/ThemeContext";

function App() {
  const [preloadCount, setPreloadCount] = useState(0);
  const [preloadDone, setPreloadDone] = useState(false);
  const comp = useRef(null);
  const main = useRef();

  // useLayoutEffect(() => {
  //   let obj = { val: 0 };
  //   let ctx = gsap.context(() => {
  //     const t1 = gsap.timeline({
  //       onComplete: () => {
  //         setPreloadDone(true);
  //       }
  //     });

  //     t1.to(obj, {
  //       val: 80,
  //       duration: 5,
  //       ease: "power1.out",
  //       onUpdate: () => setPreloadCount(Math.round(obj.val))
  //     })

  //       .to(obj, {
  //         val: 100,
  //         duration: 1.2,
  //         ease: "power1.inOut",
  //         onUpdate: () => setPreloadCount(Math.round(obj.val))
  //       })

  //       // Preloader goes up
  //       .to(".preloader", {
  //         yPercent: -100,
  //         opacity: 0,
  //         duration: 1,
  //         delay: 0.2,
  //         ease: "power2.inOut"
  //       })

  //       // Main content comes from bottom
  //       .from(".main-page-content", {
  //         y: 100,
  //         opacity: 1,
  //         duration: 1.2,
  //         ease:"bounce.out"
  //       }, "-=0.5"); // start before preloader ends completely
  //   }, comp);

  //   return () => ctx.revert();
  // }, []);
 useLayoutEffect(() => {
  let obj = { val: 0 };

  // Fallback if GSAP is throttled or delayed
  let timeoutFallback = setTimeout(() => {
    setPreloadDone(true);
  }, 8000); // timeout in ms

  let ctx = gsap.context(() => {
    const t1 = gsap.timeline({
      onComplete: () => {
        clearTimeout(timeoutFallback);
        setPreloadDone(true);
      }
    });

    t1.to(obj, {
      val: 80,
      duration: 5,
      ease: "power1.out",
      onUpdate: () => setPreloadCount(Math.round(obj.val))
    })

      .to(obj, {
        val: 100,
        duration: 1.2,
        ease: "power1.inOut",
        onUpdate: () => setPreloadCount(Math.round(obj.val))
      })

      .to(".preloader", {
        yPercent: -100,
        opacity: 0,
        duration: 1,
        delay: 0.2,
        ease: "power2.inOut"
      })

      .from(".main-page-content", {
        y: 100,
        opacity: 1,
        duration: 1.2,
        ease: "bounce.out"
      }, "-=0.5");
  }, comp);

  return () => {
    clearTimeout(timeoutFallback); // cleanup
    ctx.revert();
  };
}, []);

  return (
    <>
      <div ref={comp}>
        {!preloadDone && (
          <div className="preloader">
            <h1 className="preloader-h1">{preloadCount}%</h1>
          </div>
        )}
      </div>

      <div
        className="main-conatainer-locomotive-scroll main-page-content"
        ref={main}
        data-scroll-container
        style={{
          opacity: preloadDone ? 1 : 0,
          transition: "opacity 1s cubic-bezier(0.77,0,0.18,1)"
        }}
      >
        <ThemeProvider>
          <Navbar />
          <AllRouter />
          <Footer />
        </ThemeProvider>
      </div>
    </>
  );
}

export default App;
